// Gallery data for martial arts dojo landing page
// Separated from mock.js for better organization and management

export const galleryData = [
  // 2025 Forum des sports images
  {
    id: 701,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_103150-fotor-2025093013856.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_103150-fotor-2025093013856.jpg"
  },
  {
    id: 702,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_103304-fotor-20250930131055.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_103304-fotor-20250930131055.jpg"
  },
  {
    id: 703,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_103712-fotor-20250930131259.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_103712-fotor-20250930131259.jpg"
  },
  {
    id: 704,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_104017-fotor-20250930131447.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_104017-fotor-20250930131447.jpg"
  },
  {
    id: 705,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_104032-fotor-2025093014308.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_104032-fotor-2025093014308.jpg"
  },
  {
    id: 706,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_104254-fotor-2025093014324.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_104254-fotor-2025093014324.jpg"
  },
  {
    id: 707,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_104416-fotor-2025093014354.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_104416-fotor-2025093014354.jpg"
  },
  {
    id: 708,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_105408-fotor-20250930143552.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_105408-fotor-20250930143552.jpg"
  },
  {
    id: 709,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_105606-fotor-20250930143754.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_105606-fotor-20250930143754.jpg"
  },
  {
    id: 710,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_105612-fotor-20250930143838.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_105612-fotor-20250930143838.jpg"
  },
  {
    id: 711,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_120442-fotor-20250930144026.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_120442-fotor-20250930144026.jpg"
  },
  {
    id: 712,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_121143-fotor-2025093014427.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_121143-fotor-2025093014427.jpg"
  },
  {
    id: 713,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_121201-fotor-20250930144426.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_121201-fotor-20250930144426.jpg"
  },
  {
    id: 714,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_142958-fotor-20250930144543.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_142958-fotor-20250930144543.jpg"
  },
  {
    id: 715,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_143022-fotor-20250930144618.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_143022-fotor-20250930144618.jpg"
  },
  {
    id: 716,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_143117-fotor-2025093014475.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_143117-fotor-2025093014475.jpg"
  },
  {
    id: 717,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_154855-fotor-20250930144916.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_154855-fotor-20250930144916.jpg"
  },
  {
    id: 718,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_154920-fotor-20250930144952.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_154920-fotor-20250930144952.jpg"
  },
  {
    id: 719,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_154934-fotor-20250930145030.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_154934-fotor-20250930145030.jpg"
  },
  {
    id: 720,
    alt: "Démonstration au Forum des sports 2025",
    tags: ["2025", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2025/forum/20250830_173633-fotor-20250930145111.jpg",
    thumbnail: "/images/gallery/2025/forum/thumbnails/20250830_173633-fotor-20250930145111.jpg"
  },

  // 2024 Forum des sports images
  {
    id: 101,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03785 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03785 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 102,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03788 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03788 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 103,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03791 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03791 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 104,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03793 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03793 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 105,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration", "armes", "bokken"],
    src: "/images/gallery/2024/forum/DSC03797 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03797 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 106,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration", "armes", "bokken"],
    src: "/images/gallery/2024/forum/DSC03804 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03804 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 107,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration", "armes", "bokken"],
    src: "/images/gallery/2024/forum/DSC03807 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03807 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 108,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration", "armes", "bokken"],
    src: "/images/gallery/2024/forum/DSC03808 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03808 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 109,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration", "armes", "bokken"],
    src: "/images/gallery/2024/forum/DSC03814 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03814 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
/*  {
    id: 110,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration", "armes", "bokken", "jo"],
    src: "/images/gallery/2024/forum/DSC03818 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03818 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 111,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration", "armes", "bokken", "jo"],
    src: "/images/gallery/2024/forum/DSC03821 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03821 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 112,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration", "armes", "bokken", "jo"],
    src: "/images/gallery/2024/forum/DSC03822 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03822 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 113,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration", "armes", "bokken", "jo"],
    src: "/images/gallery/2024/forum/DSC03825 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03825 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },*/
  {
    id: 114,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03831 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03831 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 115,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03833 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03833 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 116,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03834 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03834 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 117,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03835 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03835 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 118,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03838 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03838 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 119,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03839 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03839 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 120,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03842 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03842 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 121,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03843 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03843 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 122,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03846 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03846 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 123,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration", "portrait"],
    src: "/images/gallery/2024/forum/DSC03847 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03847 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 124,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03851 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03851 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 125,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03857 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03857 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 126,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "demonstration"],
    src: "/images/gallery/2024/forum/DSC03858 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03858 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },
  {
    id: 127,
    alt: "Démonstration au Forum des sports 2024",
    tags: ["2024", "evenement", "forum des sports", "portrait"],
    src: "/images/gallery/2024/forum/DSC03859 (2).jpg",
    thumbnail: "/images/gallery/2024/forum/thumbnails/DSC03859 (2).jpg",
    caption: "Photographie de Michel CARRAYROU"
  },

  // 2018 images
  {
    id: 200,
    alt: "Forum des sports 2018 - Vidéo de Démonstration",
    tags: ["2018", "evenement", "forum des sports", "demonstration", "video"],
    src: "/images/gallery/2018/Forum-des-sports-2018-COXYAHZzOKs.mp4",
    type: "video",
    thumbnail: "/images/gallery/2018/thumbnails/smssecure-2019-04-03-204426-3.jpg"
  },
  // {
  //   id: 201,
  //   alt: "Formation aïkido 2018",
  //   tags: ["2018", "entrainement", "cours"],
  //   src: "/images/gallery/2018/smssecure-2019-04-03-204426-3.jpg",
  //   thumbnail: "/images/gallery/2018/thumbnails/smssecure-2019-04-03-204426-3.jpg"
  // },

  // 2017 images
  {
    id: 301,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "relaxation", "forum des sports", "evenement"],
    src: "/images/gallery/2017/PicMonkey-Image.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/PicMonkey-Image.jpg"
  },
  {
    id: 302,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre.jpg"
  },
  {
    id: 303,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre1.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre1.jpg"
  },
  {
    id: 304,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre2.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre2.jpg"
  },
  {
    id: 305,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre3.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre3.jpg"
  },
  {
    id: 306,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre4.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre4.jpg"
  },
  {
    id: 307,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre5.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre5.jpg"
  },
  {
    id: 308,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre6.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre6.jpg"
  },
  {
    id: 309,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre7.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre7.jpg"
  },
  {
    id: 310,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre8.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre8.jpg"
  },
  {
    id: 311,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre91.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre91.jpg"
  },
  {
    id: 312,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre93.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre93.jpg"
  },
  {
    id: 313,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre94.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre94.jpg"
  },
  {
    id: 314,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre95.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre95.jpg"
  },
  {
    id: 315,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre96.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre96.jpg"
  },
  {
    id: 316,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre97.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre97.jpg"
  },
  {
    id: 317,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre98.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre98.jpg"
  },
  {
    id: 318,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre99.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre99.jpg"
  },
  {
    id: 319,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre992.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre992.jpg"
  },
  {
    id: 320,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre993.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre993.jpg"
  },
  {
    id: 321,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre994.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre994.jpg"
  },
  {
    id: 322,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre996.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre996.jpg"
  },
  {
    id: 323,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre998.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre998.jpg"
  },
  {
    id: 324,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre999.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre999.jpg"
  },
  {
    id: 325,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre9991.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre9991.jpg"
  },
  {
    id: 326,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre9992.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre9992.jpg"
  },
  {
    id: 327,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre9993.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre9993.jpg"
  },
  {
    id: 328,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre9994.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre9994.jpg"
  },
  {
    id: 329,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre9995.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre9995.jpg"
  },
  {
    id: 330,
    alt: "Démonstration au Forum des sports 2017",
    tags: ["2017", "demonstration", "forum des sports", "evenement"],
    src: "/images/gallery/2017/Sans-titre9996.jpg",
    thumbnail: "/images/gallery/2017/thumbnails/Sans-titre9996.jpg"
  },

  // 2016 images
  {
    id: 401,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5245.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5245.jpg"
  },
  {
    id: 402,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5246.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5246.jpg"
  },
  {
    id: 403,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5254.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5254.jpg"
  },
  {
    id: 404,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5258.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5258.jpg"
  },
  {
    id: 405,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5262.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5262.jpg"
  },
  {
    id: 406,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5265.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5265.jpg"
  },
  {
    id: 407,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5266-1.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5266-1.jpg"
  },
  {
    id: 408,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5270.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5270.jpg"
  },
  {
    id: 409,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5271.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5271.jpg"
  },
  {
    id: 410,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5275.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5275.jpg"
  },
  {
    id: 411,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5282.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5282.jpg"
  },
  {
    id: 412,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5283.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5283.jpg"
  },
  {
    id: 413,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5287.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5287.jpg"
  },
  {
    id: 414,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "démonstration"],
    src: "/images/gallery/2016/IMG_5290.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5290.jpg"
  },
  {
    id: 415,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "portrait"],
    src: "/images/gallery/2016/IMG_5295.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5295.jpg"
  },
  {
    id: 416,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "portrait"],
    src: "/images/gallery/2016/IMG_5296.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5296.jpg"
  },
  {
    id: 417,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "portrait"],
    src: "/images/gallery/2016/IMG_5297.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5297.jpg"
  },
  {
    id: 418,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "portrait"],
    src: "/images/gallery/2016/IMG_5299.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5299.jpg"
  },
  {
    id: 419,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "portrait"],
    src: "/images/gallery/2016/IMG_5302.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5302.jpg"
  },
  {
    id: 420,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "portrait"],
    src: "/images/gallery/2016/IMG_5303.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5303.jpg"
  },
  {
    id: 421,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "portrait"],
    src: "/images/gallery/2016/IMG_5305.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5305.jpg"
  },
  {
    id: 422,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "portrait"],
    src: "/images/gallery/2016/IMG_5309.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5309.jpg"
  },
  {
    id: 423,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "portrait"],
    src: "/images/gallery/2016/IMG_5310.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5310.jpg"
  },
  {
    id: 424,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "portrait"],
    src: "/images/gallery/2016/IMG_5311.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5311.jpg"
  },
  {
    id: 425,
    alt: "Démonstration au Forum des sports 2016",
    tags: ["2016", "evenement", "forum des sports", "portrait"],
    src: "/images/gallery/2016/IMG_5314.jpg",
    thumbnail: "/images/gallery/2016/thumbnails/IMG_5314.jpg"
  },

  // 2015 images
  {
    id: 501,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/FORUM-2015-1552-1.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/FORUM-2015-1552-1.jpg"
  },
  {
    id: 502,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5163.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5163.jpg"
  },
  {
    id: 503,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5168.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5168.jpg"
  },
  {
    id: 504,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5171.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5171.jpg"
  },
  {
    id: 505,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5176.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5176.jpg"
  },
  {
    id: 506,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5184.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5184.jpg"
  },
  {
    id: 507,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5185.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5185.jpg"
  },
  {
    id: 508,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5188.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5188.jpg"
  },
  {
    id: 509,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5192.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5192.jpg"
  },
  {
    id: 510,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5193.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5193.jpg"
  },
  {
    id: 511,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5203.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5203.jpg"
  },
  {
    id: 512,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5205.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5205.jpg"
  },
  {
    id: 513,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5209.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5209.jpg"
  },
  {
    id: 514,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5218.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5218.jpg"
  },
  {
    id: 515,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5227-1.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5227-1.jpg"
  },
  {
    id: 516,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5230.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5230.jpg"
  },
  {
    id: 517,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5235.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5235.jpg"
  },
  {
    id: 518,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/IMG_5238.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/IMG_5238.jpg"
  },
  {
    id: 519,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/P1000727.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/P1000727.jpg"
  },
  {
    id: 520,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/P1000728.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/P1000728.jpg"
  },
  {
    id: 521,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/P1000732.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/P1000732.jpg"
  },
  {
    id: 522,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/P1000737.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/P1000737.jpg"
  },
  {
    id: 523,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/P1000738.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/P1000738.jpg"
  },
  {
    id: 524,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/P1000739.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/P1000739.jpg"
  },
  {
    id: 525,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/P1000741.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/P1000741.jpg"
  },
  {
    id: 526,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/P1000742.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/P1000742.jpg"
  },
  {
    id: 527,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/P1000745.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/P1000745.jpg"
  },
  {
    id: 528,
    alt: "Démonstration au Forum des sports 2015",
    tags: ["2015", "evenement", "forum des sports"],
    src: "/images/gallery/2015/P1000746.jpg",
    thumbnail: "/images/gallery/2015/thumbnails/P1000746.jpg"
  },

  // 2011 images
  {
    id: 601,
    alt: "Démonstration au Forum des sports 2011",
    tags: ["2011", "entrainement", "cours"],
    src: "/images/gallery/2011/o_1a68tcg3t1dd01tfi5079n59mf17.jpg",
    thumbnail: "/images/gallery/2011/thumbnails/o_1a68tcg3t1dd01tfi5079n59mf17.jpg"
  },
  {
    id: 602,
    alt: "Démonstration au Forum des sports 2011",
    tags: ["2011", "techniques", "entrainement"],
    src: "/images/gallery/2011/o_1a68tcg3tigfn041e1p73ac1k16.jpg",
    thumbnail: "/images/gallery/2011/thumbnails/o_1a68tcg3tigfn041e1p73ac1k16.jpg"
  },
  {
    id: 603,
    alt: "Démonstration au Forum des sports 2011",
    tags: ["2011", "entrainement", "techniques"],
    src: "/images/gallery/2011/o_1a68tcg3u1qdodv41bq4u3b11iq18.jpg",
    thumbnail: "/images/gallery/2011/thumbnails/o_1a68tcg3u1qdodv41bq4u3b11iq18.jpg"
  },
  {
    id: 604,
    alt: "Démonstration au Forum des sports 2011",
    tags: ["2011", "entrainement", "techniques"],
    src: "/images/gallery/2011/o_1a68tcg3uurv1oan1nm2ndg1il41a.jpg",
    thumbnail: "/images/gallery/2011/thumbnails/o_1a68tcg3uurv1oan1nm2ndg1il41a.jpg"
  },
  {
    id: 605,
    alt: "Démonstration au Forum des sports 2011",
    tags: ["2011", "entrainement", "cours"],
    src: "/images/gallery/2011/o_1a68tcg3v1mdota8ffrphv17m21c.jpg",
    thumbnail: "/images/gallery/2011/thumbnails/o_1a68tcg3v1mdota8ffrphv17m21c.jpg"
  },
  {
    id: 606,
    alt: "Démonstration au Forum des sports 2011",
    tags: ["2011", "techniques", "entrainement"],
    src: "/images/gallery/2011/o_1a68tcg401fvs13ss8uo1lfi1mf61g.jpg",
    thumbnail: "/images/gallery/2011/thumbnails/o_1a68tcg401fvs13ss8uo1lfi1mf61g.jpg"
  },
  {
    id: 607,
    alt: "Démonstration au Forum des sports 2011",
    tags: ["2011", "entrainement", "techniques"],
    src: "/images/gallery/2011/o_1a68tcg4035155p1aq9hsrbt1h.jpg",
    thumbnail: "/images/gallery/2011/thumbnails/o_1a68tcg4035155p1aq9hsrbt1h.jpg"
  },
  {
    id: 608,
    alt: "Démonstration au Forum des sports 2011",
    tags: ["2011", "entrainement", "techniques"],
    src: "/images/gallery/2011/o_1a68tcg41kcvb9t1vk11s881rcj1r.jpg",
    thumbnail: "/images/gallery/2011/thumbnails/o_1a68tcg41kcvb9t1vk11s881rcj1r.jpg"
  },
  {
    id: 609,
    alt: "Démonstration au Forum des sports 2011",
    tags: ["2011", "entrainement", "cours"],
    src: "/images/gallery/2011/o_1a68tg8eh3c684k1som1m8oh0817.jpg",
    thumbnail: "/images/gallery/2011/thumbnails/o_1a68tg8eh3c684k1som1m8oh0817.jpg"
  },
  {
    id: 610,
    alt: "Démonstration au Forum des sports 2011",
    tags: ["2011", "techniques", "entrainement"],
    src: "/images/gallery/2011/o_1a68tg8eiog91b5b1rg74d514mh19.jpg",
    thumbnail: "/images/gallery/2011/thumbnails/o_1a68tg8eiog91b5b1rg74d514mh19.jpg"
  },
  {
    id: 611,
    alt: "Démonstration au Forum des sports 2011",
    tags: ["2011", "entrainement", "techniques"],
    src: "/images/gallery/2011/o_1a68tg8ekd78ov1o8i1n2j1hc1r.jpg",
    thumbnail: "/images/gallery/2011/thumbnails/o_1a68tg8ekd78ov1o8i1n2j1hc1r.jpg"
  }
];

export default galleryData;
